export const AXIOS_CLIENT_TIMEOUT = 30_000;
export const AXIOS_BASE_PATH = '/api';
